function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "baseline-keyboard_arrow_right-24px",
  transform: "translate(-1707 -956)"
}, /*#__PURE__*/React.createElement("g", {
  id: "baseline-keyboard_arrow_right-24px-2",
  "data-name": "baseline-keyboard_arrow_right-24px",
  transform: "translate(1707 970.379) rotate(-90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M8.59,12.345l2.744-2.75L8.59,6.845,9.435,6,13.03,9.595,9.435,13.19Z",
  transform: "translate(-3.443 -2.405)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M0,0H14.38V14.38H0Z",
  fill: "none"
})));

var SvgArrowUp = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.38,
    height: 14.38,
    viewBox: "0 0 14.38 14.38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-up.778206d9.svg";
export { ForwardRef as ReactComponent };